import { Component, DestroyRef, HostListener, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ModalService } from '../../services/modal.service';
import { SpacesService } from '../../services/spaces.service';
import { Note } from '../../models/space.model';

@Component({
    selector: 'app-add-note-modal',
    imports: [FormsModule, TranslateModule],
    templateUrl: './add-note-modal.component.html',
    styleUrl: './add-note-modal.component.scss'
})
export class AddNoteModalComponent implements OnInit {
  isVisible = false;
  noteContent = '';
  private spaceId = '';
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private readonly modalService: ModalService,
    private readonly spacesService: SpacesService
  ) {}

  ngOnInit(): void {
    this.modalService.modal$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(config => {
      this.isVisible = config.type === 'add-note';
      if (this.isVisible && config.spaceId) {
        this.spaceId = config.spaceId;
        this.noteContent = '';
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (!this.isVisible) return;
    
    if (event.key === 'Escape') {
      this.closeDialog();
    } else if (event.ctrlKey && event.key === 'Enter' && this.canSubmit) {
      this.addNote();
    }
  }

  get canSubmit(): boolean {
    return this.noteContent.trim().length > 0;
  }

  closeDialog(): void {
    this.modalService.closeModal();
  }

  addNote(): void {
    if (!this.canSubmit) return;

    const space = this.spacesService.get(this.spaceId);
    const note: Note = {
      text: this.noteContent.trim(),
      creator: space?.ownerName ?? '',
      createdAt: new Date()
    };

    this.spacesService.addNote(this.spaceId, note);
    this.closeDialog();
  }
}
